const boxCls = "_rsb5lpygx";
const spacingCls = "_rssth4weu";
const headingsCls = "_rsh1o2hbq2";
const ribbonLabelCls = "_rsr1cyoed0";

// Prepares proper rendering of richtext content
const containerCls = "_rscksp3jx";
const contentCls = "_rscvxiglx";

export { boxCls, containerCls, contentCls, headingsCls, ribbonLabelCls, spacingCls };
import "./text-component.style.linaria.module.css";
//# sourceMappingURL=text-component.style.js.map
